import { Modal } from "src/components";
import AddNoteForm, { AddNoteFormValues } from "./AddNoteForm";

interface Props {
  closeModal: () => void;
  initialValues: AddNoteFormValues;
  onSubmit: (v: AddNoteFormValues) => void;
  title: string;
}

const AddNoteModal = ({ closeModal, onSubmit, initialValues, title }: Props) => {
  return (
    <Modal size="medium" onClose={closeModal} padding="medium" title={title}>
      <AddNoteForm onSubmit={onSubmit} initialValues={initialValues} />
    </Modal>
  );
};

export default AddNoteModal;
